import axios from 'axios'
import configs from './../configs'
import GenericDAO from './../generic-dao'

const failed = new Promise(resolve => { resolve(false) })

const findAll = (params) => GenericDAO.find(`/medclub/nota-fiscal/listar/`, params)
const findByTransacaoFinanceira = (id) => GenericDAO.find(`/medclub/nota-fiscal/transacoes-financeiras/${id}/`)
const alterarPagante = (params) => GenericDAO.save(`/medclub/nota-fiscal/alterar-pagante/`, params)
const processar = (params) => GenericDAO.save(`/medclub/nota-fiscal/processar/`, params)
const cadastrar = (params) => GenericDAO.save(`/medclub/nota-fiscal/`, params)
const findAllTokenNFPJ = (params) => GenericDAO.find(`/medclub/nota-fiscal/token-pj/`, params)
const saveTokenNFPJ = (params) => GenericDAO.save('/medclub/nota-fiscal/token-pj/', params)

const updateTokenNFPJ = (dataSend) => {
    let usuario = JSON.parse(localStorage.getItem('usuario'));
    if (!usuario) return failed;

    const id = dataSend.get('id');
    if (!id) {
        console.error("ID não encontrado no FormData");
        return failed;
    }

    const path = `/medclub/nota-fiscal/token-pj/${id}`;
    return axios.patch(
        `${configs.baseUrl}${path}`,
        dataSend,
        {
            headers: {
                'Authorization': `${usuario.tokenType} ${usuario.accessToken}`,
            },
        }
    )
    .then(response => response)
    .catch(configs.errorHandler);
};

const getArquivoNfse = (id) => GenericDAO.find(`/medclub/nota-fiscal/${id}/arquivo/`)

export default {
    findByTransacaoFinanceira,
    alterarPagante,
    processar,
    cadastrar,
    findAll,
    findAllTokenNFPJ,
    saveTokenNFPJ,
    updateTokenNFPJ,
    getArquivoNfse,
}